import { ContentHeader } from '@components';
import DoiMatKhau from './DoiMatKhau';
import ThongTinCaNhan from './ThongTinCaNhan';
import { Tabs } from 'antd';

const Profile = () => {
    return (
        <>
            <ContentHeader title="Profile" />
            <section className="content">
                <Tabs defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Thông tin',
                        children:
                            <div className="card pt-3 pb-2">
                                <ThongTinCaNhan />
                            </div>
                    },
                    {
                        key: '2',
                        label: 'Đổi mật khẩu',
                        children:
                            <div className="card pt-3 pb-2">
                                <DoiMatKhau />
                            </div>
                    }
                ]}>
                </Tabs>
            </section>
        </>
    );
};

export default Profile;
